<script setup lang="ts">
interface DialogButton {
  label: string;
  onClick?: () => void;
}

const props = withDefaults(
  defineProps<{
    title?: string;
    description?: string;
    buttons?: DialogButton[];
  }>(),
  {
    buttons: () => [],
  }
);

const open = defineModel<boolean>("open", { default: false });

const ui = {
  overlay: "transition-opacity duration-100",
  content: "ring-0! transition-all duration-100 rounded-lg shadow-none! w-full sm:max-w-76",
  header: "text-base sm:px-4 first:pt-6 pb-0! mb-6 border-b-0 min-h-auto [&:not(:has(>button))_[data-slot=title]]:text-center",
  body: "border-none! sm:px-4 sm:pt-1 sm:first:pt-6 sm:pb-6",
  footer: "flex flex-col items-stretch sm:px-4 pt-0 pt-0! first:mt-6 last:pb-6",
  wrapper: "grow",
  title: "text-xl text-highlighted font-semibold not-last:pb-3",
  description: "mt-2 text-base text-primary text-center",
  close: "top-2.5 end-2.5",
};
</script>

<template>
  <UModal v-model:open="open" :close="false" :scrollable="true" :title="title" :description="description" :ui="ui">
    <template v-if="$slots.description" #description>
      <slot name="description" />
    </template>
    <template v-if="$slots.body" #body>
      <slot name="body" />
    </template>
    <template v-if="buttons.length" #footer>
      <div class="flex flex-col items-stretch border-t border-blue-300 divide-y divide-blue-300 -mb-4.5">
        <div v-for="(button, index) in buttons" :key="index" class="flex justify-center py-1.5">
          <UButton variant="ghost" color="blue" class="w-full justify-center" @click="button.onClick?.()">
            {{ button.label }}
          </UButton>
        </div>
      </div>
    </template>
  </UModal>
</template>
